import styled from 'styled-components';

import { FooterLinkStyles } from '../login/login.component.styles';

const Login = styled.p`
  ${FooterLinkStyles}
`;

// BET-337
// ErrorLink should be in signup-form.component.styles.js but importing that file would cause styles loss on browser refresh
// We might want to take a look at https://www.styled-components.com/docs/advanced#server-side-rendering
const ErrorLink = styled.a`
  color: #fff;
`;

export { Login, ErrorLink };



// WEBPACK FOOTER //
// ./src/signup/signup.component.styles.js